/* istanbul ignore file */
export * from './SearchKimRating';
